import { SET_POSITION } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const setPosition = position => ({
  type: SET_POSITION,
  payload: position,
});




// WEBPACK FOOTER //
// ./src/app/position/actions.js